<template>
    <div v-if="GET_REVIEW" class="w-full">
        <div class="mt-8 text-base text-black mb-3">
            {{ GET_REVIEW.question }}
        </div>
        <input-textarea
            v-if="GET_REVIEW.answer_type == 'freeText' && !isDemo"
            :id="'answer-' + GET_REVIEW.id"
            :label="'Antwort'"
            :name="'answer-' + GET_REVIEW.id"
            v-model="GET_CUSTOMER_REVIEW.answer"
            :labelClass="'bg-white'"
            class="w-full"
            :heightClass="'h-32'"
            @change="
                () => {
                    if (!isDemo) UPDATE_CUSTOMER_REVIEWS();
                }
            "
        />
        <input-textarea
            v-else-if="GET_REVIEW.answer_type == 'freeText' && isDemo"
            :id="'answer-' + GET_REVIEW.id"
            :label="'Antwort'"
            :name="'answer-' + GET_REVIEW.id"
            v-model="state.demo.answer"
            :labelClass="'bg-white'"
            class="w-full"
            :heightClass="'h-32'"
            @change="
                () => {
                    if (!isDemo) UPDATE_CUSTOMER_REVIEWS();
                }
            "
        />
        <input-grades
            v-else-if="GET_REVIEW.answer_type == 'grades' && !isDemo"
            :modelValue="GET_CUSTOMER_REVIEW.answer"
            @change="
                (value) => {
                    GET_CUSTOMER_REVIEW.answer = `${value}`;
                    UPDATE_CUSTOMER_REVIEWS();
                }
            "
        />

        <input-grades
            v-else-if="GET_REVIEW.answer_type == 'grades' && isDemo"
            :modelValue="state.demo.answer"
            @change="
                (value) => {
                    state.demo.answer = `${value}`;
                }
            "
        />
        <div class="w-full" v-else-if="GET_REVIEW.answer_type == 'radio'">
            <input-radio
                v-for="(option, index) in isDemo
                    ? GET_REVIEW.options
                    : GET_CUSTOMER_REVIEW.customerOptions"
                :key="index"
                class="mb-4"
                :name="
                    `customer-option-${
                        isDemo ? GET_REVIEW.options.id : GET_CUSTOMER_REVIEW.id
                    }-${index}`
                "
                :id="
                    `customer-option-${
                        isDemo ? GET_REVIEW.options.id : GET_CUSTOMER_REVIEW.id
                    }-${index}`
                "
                :modelValue="option.is_checked ?? false"
                :defaultColor="'grey'"
                :label="option.text"
                :activeColor="'primary'"
                @change="
                    if (!option.is_checked) {
                        if (isDemo) {
                            GET_REVIEW.options.forEach(
                                (o) => (o.is_checked = false)
                            );
                        } else {
                            GET_CUSTOMER_REVIEW.customerOptions.forEach(
                                (o) => (o.is_checked = false)
                            );
                        }
                        option.is_checked = true;
                        if (!isDemo) {
                            UPDATE_CUSTOMER_REVIEWS();
                        }
                    }
                "
            />
        </div>
        <div class="w-full" v-else-if="GET_REVIEW.answer_type == 'prospect'">
            <input-checkbox
                v-for="(option, index) in isDemo
                    ? GET_REVIEW.options
                    : GET_CUSTOMER_REVIEW.customerOptions"
                :key="index"
                class="mb-4"
                :name="
                    `customer-option-${
                        isDemo ? GET_REVIEW.options.id : GET_CUSTOMER_REVIEW.id
                    }-${index}`
                "
                :id="
                    `customer-option-${
                        isDemo ? GET_REVIEW.options.id : GET_CUSTOMER_REVIEW.id
                    }-${index}`
                "
                :modelValue="option.is_checked ?? false"
                :defaultColor="'grey'"
                :label="option.text"
                :activeColor="'primary'"
                @change="
                    if (option.is_checked) {
                        option.is_checked = false;
                    } else {
                        option.is_checked = true;
                    }
                    if (!isDemo) {
                        UPDATE_CUSTOMER_REVIEWS();
                    }
                "
            />
        </div>
        <div class="w-full" v-else-if="GET_REVIEW.answer_type == 'checkbox'">
            <input-checkbox
                v-for="(option, index) in isDemo
                    ? GET_REVIEW.options
                    : GET_CUSTOMER_REVIEW.customerOptions"
                :key="index"
                class="mb-4"
                :name="
                    `customer-option-${
                        isDemo ? GET_REVIEW.options.id : GET_CUSTOMER_REVIEW.id
                    }-${index}`
                "
                :id="
                    `customer-option-${
                        isDemo ? GET_REVIEW.options.id : GET_CUSTOMER_REVIEW.id
                    }-${index}`
                "
                :modelValue="option.is_checked ?? false"
                :defaultColor="'grey'"
                :label="option.text"
                :activeColor="'primary'"
                @change="
                    if (option.is_checked) {
                        option.is_checked = false;
                    } else {
                        option.is_checked = true;
                    }
                    if (!isDemo) {
                        UPDATE_CUSTOMER_REVIEWS();
                    }
                "
            />
        </div>
    </div>
</template>

<script>
import { computed, defineComponent, reactive } from "@vue/runtime-core";
import { useStore } from "vuex";
import { getData } from "../../../../common/dataHelper";
import InputCheckbox from "../../../../components/input/InputCheckbox.vue";
import InputGrades from "../../../../components/input/InputGrades.vue";
import InputRadio from "../../../../components/input/InputRadio.vue";
import InputTextarea from "../../../../components/input/InputTextarea.vue";
import {
    AUTH_USER_TYPES,
    COURSE_TYPES,
    STORE_TYPES,
} from "../../../../store/types";

export default defineComponent({
    name: "Review",
    props: {
        reviewId: { type: Number, required: true },
        type: { type: String, required: true },
    },
    components: { InputGrades, InputTextarea, InputCheckbox, InputRadio },
    setup(props) {
        const store = useStore();
        /**
         *  State
         */
        const state = reactive({ demo: {} });
        /**
         *  Functions
         */
        async function UPDATE_CUSTOMER_REVIEWS() {
            const response = await store.dispatch(
                `${STORE_TYPES.COURSES}/${COURSE_TYPES.UPDATE_CUSTOMER_REVIEWS}`,
                {
                    review: GET_REVIEW.value,
                }
            );
            return response;
        }

        /**
         *  Computed
         */
        const GET_COURSE = computed(
            () =>
                store.getters[
                    `${STORE_TYPES.COURSES}/${COURSE_TYPES.GET_COURSE}`
                ]
        );
        const GET_REVIEWS = computed(() => {
            if (
                props.type == "targetAgreement" &&
                getData(GET_COURSE, "value.reviews.targetAgreement") == null
            ) {
                return [];
            } else if (props.type == "targetAgreement") {
                return GET_COURSE.value.reviews.targetAgreement;
            } else if (
                props.type == "feedback" &&
                getData(GET_COURSE, "value.reviews.feedback") == null
            ) {
                return [];
            } else {
                return GET_COURSE.value.reviews.feedback;
            }
        });
        const GET_REVIEW = computed(() => {
            return GET_REVIEWS.value.find(
                (review) => review.id == props.reviewId
            );
        });
        const GET_CUSTOMER_REVIEW = computed(() => {
            console.log(GET_REVIEW.value);
            return GET_REVIEW.value.customerReviews[0];
        });
        const GET_USER = computed(() => {
            return store.getters[
                `${STORE_TYPES.AUTH_USER}/${AUTH_USER_TYPES.GET_USER}`
            ];
        });

        const isDemo = computed(() => {
            if (GET_USER.value.authorizations) {
                return GET_USER.value.authorizations.some(
                    (a) => a.name == "Demozugriff"
                );
            }
            return false;
        });

        /**
         *  Created
         */

        return {
            state,
            UPDATE_CUSTOMER_REVIEWS,
            GET_REVIEW,
            GET_CUSTOMER_REVIEW,
            isDemo,
        };
    },
});
</script>  
